
var countries = require('./country-data.js')
/*==========  Map  ==========*/
var map;

function fill_countries() {
  var country = $('#country')
  $.map(countries, function (val, i) {
    country.append(
        $('<option>')
        .attr({
          'class': 'country-option',
          'value': val.code
        })
        .text(val.name)
    )
  })
  $.get("https://ipinfo.io", function(response) {
    console.log(response.city, response.country);
    $('#city').attr('value', response.city)
    $('.country-option').each(function (index, elem) {
      var option = $(this)
      var optionValue = option.attr('value')
      if(option.attr('value') === response.country) {
        option.attr('selected', true)
      }
    })
  }, "jsonp");
}

function initialize_map() {
  if ($('#map').length) {
    var myLatLng = new google.maps.LatLng(-37.814199, 144.961560);
    var mapOptions = {
      zoom: 17,
      center: myLatLng,
      scrollwheel: false,
      panControl: false,
      zoomControl: true,
      scaleControl: false,
      mapTypeControl: false,
      streetViewControl: false
    };
    map = new google.maps.Map(document.getElementById('map'), mapOptions);
    var marker = new google.maps.Marker({
      position: myLatLng,
      map: map,
      tittle: 'Envato',
      icon: './images/map-locator.png'
    });
  } else {
    return false;
  }
}

fill_countries()
google.maps.event.addDomListener(window, 'load', initialize_map);

/*-----------------------------------------------------------------------------------*/
/*    FORM SUBMIT
/*-----------------------------------------------------------------------------------*/
function checkmail(input){
  var pattern1=/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
  if(pattern1.test(input)) {
		return true;
	} else {
		return false;
	}
}

function proceed(){
  var name = document.getElementById("name");
	var email = document.getElementById("email");
	var country = document.getElementById("country");
	var city = document.getElementById("city");
	var company = document.getElementById("company");
	var web = document.getElementById("website");
	var msg = document.getElementById("message");
	var errors = "";
	if(name.value == ""){ 
		name.className = 'error';
  	return false;
	} else if(email.value == ""){
		email.className = 'error';
		return false;
	} else if(checkmail(email.value)==false) {
	  alert('Please provide a valid email address.');
	  return false;
	} else if(country.value == "") {
	  country.className = 'error';
	  return false;
	} else if(city.value == "") {
	  city.className = 'error';
	  return false;
	} else if(company.value == "") {
	  company.className = 'error';
	  return false;
	} else if(web.value == "") {
	  web.className = 'error';
	  return false;
	} else if(msg.value == "") {
	  msg.className = 'error';
	  return false;
	} else {
		$.ajax({
			type: "POST",
			url: "php/submit.php",
			data: $("#contact_form").serialize(),
			success: function(msg) {
				if(msg === 'true') {
					$('#contact_form').fadeOut(500);
					$('#contact_message').fadeIn(500);
						document.getElementById("contact_message");
					 return true;
				} else {
          alert('An error occurred while sending mail, please try again later')
        }
			}
		});
	}
};

window.proceed = proceed